import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { buttonTertiaryStyles } from '@nib-components/theme';
import BaseButton, { sizeStyling, fullWidthStyling } from '../BaseButton';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const TertiaryButton = styled(_ref => {
  let {
    theme,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(BaseButton, {
    "data-mesh-component": "BUTTON-TERTIARY",
    ...otherProps
  });
})`
  ${props => buttonTertiaryStyles(props).normal}

  ${props => props.selected && css`
      ${buttonTertiaryStyles(props).selected};
    `}

  ${props => 'disabled' in props && props.disabled && css`
      ${buttonTertiaryStyles(props).disabled};
    `}

  ${props => props && css`
      &:disabled {
        ${buttonTertiaryStyles(props).disabled};
      }
    `}

    ${sizeStyling}
    ${fullWidthStyling}
`;
TertiaryButton.displayName = 'TertiaryButton';